import React from "react";
import Layout from "../../components/Layout";
import TaxSummary from "./components/TaxSummary";

const TaxSummaryContainer: React.FC = () => {
  return (
    <Layout>
      <TaxSummary />
    </Layout>
  );
};

export default TaxSummaryContainer;
